import { useFilters } from '../context/FilterContext';
import { useApi } from '../hooks/useApi';
import LeagueCard from '../components/LeagueCard';

export default function Leagues() {
  const { region, step } = useFilters();

  const params = new URLSearchParams();
  if (region) params.set('region', region);
  if (step) params.set('step', step);
  const { data, loading } = useApi(`/api/leagues?${params.toString()}`);

  const leagues = data?.leagues || [];

  if (loading) {
    return (
      <div className="space-y-6 animate-pulse">
        <div>
          <div className="h-3 w-28 rounded bg-surface-container-high mb-3" />
          <div className="h-9 w-44 rounded-lg bg-surface-container-high mb-3" />
          <div className="h-4 w-36 rounded bg-surface-container-high" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bg-surface-container border border-outline-variant/30 rounded-xl p-5">
              <div className="h-5 w-3/4 rounded bg-surface-container-high mb-4" />
              <div className="flex gap-2">
                <div className="h-5 w-20 rounded-full bg-surface-container-high" />
                <div className="h-5 w-14 rounded-full bg-surface-container-high" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header>
        <p className="font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-on-surface-variant mb-2">
          Competitions
        </p>
        <h2 className="font-expanded text-3xl sm:text-4xl font-headline font-extrabold tracking-tight text-on-surface mb-2">
          Leagues
        </h2>
        <p className="text-sm text-on-surface-variant">
          {leagues.length} active leagues{region ? ` in ${region}` : ''}{step ? ` at Step ${step}` : ''}
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {leagues.map((league) => (
          <LeagueCard key={league.id} league={league} />
        ))}
      </div>

      {leagues.length === 0 && (
        <div className="bg-surface-container-low border border-outline-variant/30 rounded-xl text-center py-16 px-6">
          <span className="material-symbols-outlined text-4xl text-outline mb-3 block">search_off</span>
          <p className="font-headline font-bold text-on-surface mb-1">No leagues found</p>
          <p className="text-sm text-on-surface-variant">No leagues match the current filters.</p>
        </div>
      )}
    </div>
  );
}
